import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay]);

// Swipers
const swiperHero = new Swiper('.swiper-hero', {
  pagination: {
    el: '.swiper-pagination',
  },
  navigation: {
    nextEl: '.swiper-hero-next',
    prevEl: '.swiper-hero-prev',
  },
  loop: true,
  autoplay: {
    delay: 8000
  },
});

const swiperReview = new Swiper('.swiper-review', {
  // Local parameters
  centeredSlides: true,
  loop: true,
  autoplay: true,
  // Responsive breakpoints
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    900: {
      slidesPerView: "auto",
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

const swiperMenu = new Swiper('.swiper-menu', {
  // Local parameters
  centeredSlides: true,
  // Responsive breakpoints
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    900: {
      slidesPerView: "auto",
      spaceBetween: 70,
    }
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});



// Mobile navigation
// - Lock scroll on Mobile Navigation
const navToggle = document.querySelector("#nav-toggle")
navToggle.addEventListener("click", (e) => {
const navLayout = document.querySelector(".header-nav__mobile")
  navToggle.classList.toggle("nav-toggle--active")
  navLayout.classList.toggle("header-nav__mobile--open")
})

// Menu-block Arrows
const mondayToggle = document.querySelector("#monday-toggle")
const tuesdayToggle = document.querySelector("#tuesday-toggle")
const wednesdayToggle = document.querySelector("#wednesday-toggle")
const thursdayToggle = document.querySelector("#thursday-toggle")
const fridayToggle = document.querySelector("#friday-toggle")

if (document.body.contains(mondayToggle)) {
  mondayToggle.addEventListener("click", (e) => {
    mondayToggle.querySelector(".arrow-down-black").classList.toggle("arrow-down-black--active")
  })
}

if (document.body.contains(tuesdayToggle)) {
  tuesdayToggle.addEventListener("click", (e) => {
    tuesdayToggle.querySelector(".arrow-down-black").classList.toggle("arrow-down-black--active")
  })
}

if (document.body.contains(wednesdayToggle)) {
  wednesdayToggle.addEventListener("click", (e) => {
    wednesdayToggle.querySelector(".arrow-down-black").classList.toggle("arrow-down-black--active")
  })
}

if (document.body.contains(thursdayToggle)) {
  thursdayToggle.addEventListener("click", (e) => {
    thursdayToggle.querySelector(".arrow-down-black").classList.toggle("arrow-down-black--active")
  })
}
if (document.body.contains(fridayToggle)) {
  fridayToggle.addEventListener("click", (e) => {
    fridayToggle.querySelector(".arrow-down-black").classList.toggle("arrow-down-black--active")
  })
}

// Window Scroll Header
window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  const header = document.querySelector(".nav-layout");
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    document.getElementById("header-logo").style.height = "60px";
  }
  else {
    document.getElementById("header-logo").style.height = "74px";
  }
}
